module.exports = __webpack_public_path__ + "assets/images/USD1.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USD1.png
// module id = 1450
// module chunks = 1